// extracted by mini-css-extract-plugin
export default {"container":"TagItem_container__tD3Ff","selected":"TagItem_selected__bTyhu"};